module.exports = __webpack_public_path__ + "img/work-roasted.da39b20e.png";